const SEGMENT_SEPARATOR = /[;,]/;
const NAMED_PAREN_WITH_COUNT = /^\(([A-Za-z]+\d*)\s*-\s*(\d+)\)\s*-\s*(\d+)$/;
const RANGE_WITH_COUNT = /^\((\d+)\s*-\s*(\d+)\)\s*-\s*(\d+)$/;
const NAMED_PAIR = /^([A-Za-z]+\d*)\s*-\s*(\d+)$/;
const PAIR = /^(\d+)\s*-\s*(\d+)$/;
const SINGLE = /^(\d+)$/;

const normalizeDashes = (value: string) => value.replace(/[–—]/g, '-');

export type ResidenceParamSegment = {
  floor: string | null;
  range: string | null;
  value: string;
};

const parseSegment = (raw: string): ResidenceParamSegment | null => {
  const segment = normalizeDashes(raw).trim();
  if (!segment) return null;

  const namedParen = segment.match(NAMED_PAREN_WITH_COUNT);
  if (namedParen) {
    return {
      floor: `${namedParen[1]}-${namedParen[2]}`,
      range: null,
      value: namedParen[3]
    };
  }

  const rangeWithCount = segment.match(RANGE_WITH_COUNT);
  if (rangeWithCount) {
    return {
      floor: null,
      range: `${rangeWithCount[1]}-${rangeWithCount[2]}`,
      value: rangeWithCount[3]
    };
  }

  const namedPair = segment.match(NAMED_PAIR);
  if (namedPair) {
    return {
      floor: namedPair[1],
      range: null,
      value: namedPair[2]
    };
  }

  const pair = segment.match(PAIR);
  if (pair) {
    return {
      floor: pair[1],
      range: null,
      value: pair[2]
    };
  }

  const single = segment.match(SINGLE);
  if (single) {
    return {
      floor: null,
      range: null,
      value: single[1]
    };
  }

  return null;
};

export const parseResidenceParamSegments = (
  values: Array<string | null | undefined>
): ResidenceParamSegment[] => {
  const segments: ResidenceParamSegment[] = [];

  values.forEach(raw => {
    if (!raw) return;

    normalizeDashes(raw)
      .split(SEGMENT_SEPARATOR)
      .forEach(part => {
        const parsed = parseSegment(part);
        if (parsed) segments.push(parsed);
      });
  });

  return segments;
};
